import { FormControl, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import { PER_PAGE } from '../constants';
import { usePagination } from '../../../hooks';
import { memo, useCallback } from 'react';

const CreativePerPage = memo(() => {
  const { perPage, setPerPage } = usePagination();

  const handleRowsPerPageSelectChange = useCallback(
    (event: SelectChangeEvent<number>) => {
      setPerPage(event.target.value as number);
    },
    [setPerPage]
  );

  return (
    <FormControl sx={{ width: 80 }} id="perpage-control">
      <InputLabel id="per-page-label">Per page</InputLabel>
      <Select
        size="small"
        id="perpage-list"
        value={perPage}
        labelId="perPage"
        label="Per page"
        onChange={handleRowsPerPageSelectChange}
        sx={{
          minWidth: 80,
          borderRadius: '8px',
          '&.MuiInputBase-sizeSmall': {
            minWidth: 80,
            borderRadius: '8px',
          },
        }}
        inputProps={{
          id: 'perpage-input',
        }}
      >
        {PER_PAGE.map(value => <MenuItem key={`topParPageOption.${value}`} value={value}>{value}</MenuItem>)}
      </Select>
    </FormControl>
  )
})

CreativePerPage.displayName = 'CreativePerPage';

export default CreativePerPage;
